module.exports = {
  crm_statuses: [
    {
      value: 'new',
      caption: 'Новый',
    },
    {
      value: 'in_work',
      caption: 'В работе',
    },
    {
      value: 'closed',
      caption: 'Закрыт',
    },
  ],
};
